import { FC } from 'react'

import { useAuthenticatedLayout } from '../context'

import {
  topFigure,
  topFigureTitle,
  topFigureDescription,
  topFigureDesBelow,
  topFigureDescription2,
  bottomFigure,
  bottomFigureDesBelow,
  bottomFigureDescription,
  bottomFigureDescription2,
  bottomFigureTitle
} from './styles.css'
import PageContents from '../PageContents'
import PageRegion from '../PageRegion'

export const PageSkeleton: FC = () => {
  const { pageHeadRef } = useAuthenticatedLayout()

  return (
    <>
      <figure ref={pageHeadRef} className={topFigure} title="Loading...">
        <div className={topFigureTitle} />

        <div className={topFigureDescription} />

        <div className={topFigureDesBelow}>
          <div className={topFigureDescription} />
          <div className={topFigureDescription2} />
        </div>
      </figure>

      <PageRegion containerProps={{ style: { cursor: 'progress' } }}>
        <PageContents mainClassName={bottomFigure}>
          <div className={bottomFigureTitle} />

          <div className={bottomFigureDescription} />

          <div className={bottomFigureDesBelow}>
            <div className={bottomFigureDescription} />
            <div className={bottomFigureDescription2} />
          </div>
        </PageContents>
      </PageRegion>
    </>
  )
}

export default PageSkeleton
